import React from "react";

import { Button, ButtonGroup, Icon } from "aible";

import SelectedFeatureChart from "components/FeatureChart/SelectedFeatureChart";
import ModelsChart from "components/nHotdogChart/ModelsChart";
import PartialDepPlotContainer from "containers/RunPlot/PartialDepPlot";

import MiniContainer from "containers/Results/Mini";
import { SECTIONS } from "components/UnifiedProject/Train/Train";

import styles from "./style.module.css";

const HIDE_REMOVE_VALUE = true;

export default class PredictionDriversCompanion extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  getRetFieldSelect() {
    const { fieldSelect, fields } = this.props;

    return fields && fieldSelect
      ? fields[fieldSelect]
        ? fieldSelect
        : fields[fieldSelect.replace("_month", "")]
          ? fieldSelect.replace("_month", "")
          : fields[fieldSelect.replace("_day", "")]
            ? fieldSelect.replace("_day", "")
            : fields[fieldSelect.replace("_weekday", "")]
              ? fieldSelect.replace("_weekday", "")
              : fieldSelect
      : fieldSelect;
  }

  handleRemove() {
    const { valueSelect, fields, ignored, ignoredValue, updateIgnored, updateIgnoredValue } = this.props;

    const fieldSelect = this.getRetFieldSelect();

    if (fieldSelect && (HIDE_REMOVE_VALUE || valueSelect === undefined)) {
      const isIgnored = ignored ? ignored[fieldSelect] : false;

      return updateIgnored(fieldSelect, !isIgnored);
    } else if (
      !HIDE_REMOVE_VALUE &&
      fieldSelect &&
      valueSelect &&
      fields &&
      fields[fieldSelect] &&
      fields[fieldSelect].type === "categorical"
    ) {
      const isIgnored = ignoredValue && ignoredValue[fieldSelect] ? ignoredValue[fieldSelect][valueSelect] : false;

      return updateIgnoredValue(fieldSelect, valueSelect, !isIgnored);
    }

    return Promise.resolve();
  }

  render() {
    const {
      id,
      models,
      model,
      featureBars,
      selectedFeatureBars,
      modelBars,
      fields,
      updateFieldSelect,
      ignored,
      ignoredValue,
      valueSelect,
      predictionDriversMode,
      updateValueSelect,
      updateFeatureSelection,
      updatePredictionDriversMode,
      isUnified,
      fids,
      clearSelect,
      splitColumn
    } = this.props;

    const fieldSelect = this.getRetFieldSelect();

    const selectedField =
      fields && fieldSelect
        ? fields[fieldSelect]
          ? fields[fieldSelect]
          : fields[fieldSelect.replace("_month", "")]
            ? fields[fieldSelect.replace("_month", "")]
            : fields[fieldSelect.replace("_day", "")]
              ? fields[fieldSelect.replace("_day", "")]
              : fields[fieldSelect.replace("_weekday", "")]
                ? fields[fieldSelect.replace("_weekday", "")]
                : undefined
        : undefined;
    let isIgnored = false;
    if (fieldSelect && (HIDE_REMOVE_VALUE || valueSelect === undefined)) {
      isIgnored = ignored ? ignored[fieldSelect] : false;
    } else if (
      !HIDE_REMOVE_VALUE &&
      fieldSelect &&
      valueSelect &&
      fields &&
      fields[fieldSelect] &&
      fields[fieldSelect].type === "categorical"
    ) {
      isIgnored = ignoredValue && ignoredValue[fieldSelect] ? ignoredValue[fieldSelect][valueSelect] : false;
    }

    const isValueSelect =
      fieldSelect && valueSelect && fields && fields[fieldSelect] && fields[fieldSelect].type === "categorical";

    const isSplitColumn = fieldSelect === splitColumn;

    let displayPredictionMode = <div />;
    let buttonStyles = {
      drillDown: false,
      modelComparison: false,
      marginalEffects: false
    };

    const paddingStyle = undefined;
    // { padding: "2px 6px" };

    if (fieldSelect === undefined) {
      return isUnified ? (
        <MiniContainer fids={fids} id={id} section={SECTIONS.OVERVIEW} isUnified />
      ) : (
        <div className={styles.emptyMsg}>{"Select a value on the left side to see more details"}</div>
      );
    }

    switch (predictionDriversMode) {
      case "drillDown":
        buttonStyles.drillDown = true;
        displayPredictionMode = (
          <SelectedFeatureChart
            {...this.props}
            bars={selectedFeatureBars}
            selected={valueSelect}
            handleSelect={(label) => updateValueSelect(label)}
          />
        );
        break;
      case "modelComparison":
        buttonStyles.modelComparison = true;
        displayPredictionMode = (
          <ModelsChart
            {...this.props}
            bars={modelBars}
            selected={model ? model.id : undefined}
            selectedName={model ? model.label : undefined}
            // label={valueSelect ? fieldSelect + ": " + valueSelect : fieldSelect}
            handleSelect={(label) => updateFeatureSelection(label)}
            isFullChart={true}
          />
        );
        break;
      case "marginalEffects":
        buttonStyles.marginalEffects = true;
        displayPredictionMode = (
          <PartialDepPlotContainer
            {...this.props}
            model={model}
            selected={valueSelect}
            fieldSelect={fieldSelect}
            updateFieldSelect={updateFieldSelect}
            isFieldSelect={fieldSelect !== undefined}
            isFullChart={true}
          />
        );
        break;
      default:
        displayPredictionMode = (
          <div>
            <p>{"Select a View Mode"}</p>
          </div>
        );
    }

    return (
      <div className={styles.predictionDriversCompanion}>
        <div className={styles.predictionDriversCompanionLabel}>
          <span>
            {(fieldSelect ? fieldSelect : "") +
              (fieldSelect && valueSelect ? ": " : "") +
              (valueSelect ? valueSelect : "")}
          </span>
          {!isSplitColumn &&
            selectedField &&
            (HIDE_REMOVE_VALUE ||
              valueSelect === undefined ||
              (selectedField && selectedField.type === "categorical")) && (
              <Button
                type="secondary"
                style={{ ...paddingStyle, marginLeft: "10px" }}
                onClick={() => this.handleRemove()}
                isSmall
              >
                <div className={styles.predictionDriversButtonContent}>
                  <Icon type={isIgnored ? "undo" : "remove"} size={13} />
                  <span style={{ marginLeft: "6px" }}>
                    {!HIDE_REMOVE_VALUE && isValueSelect
                      ? isIgnored
                        ? "Undo Remove Value"
                        : "Remove Value"
                      : isIgnored
                        ? "Undo Remove Variable"
                        : "Remove Variable"}
                  </span>
                </div>
              </Button>
            )}
          {isUnified && (valueSelect === undefined || selectedField) /*&& selectedField.type === "categorical"*/ && (
            <Button type="secondary" style={{ ...paddingStyle, marginLeft: "auto" }} onClick={clearSelect} isSmall>
              <div className={styles.predictionDriversButtonContent}>
                <Icon type={"timesPurple"} size={13} />
                <span style={{ marginLeft: "6px" }}>{"Close"}</span>
              </div>
            </Button>
          )}
        </div>
        <ButtonGroup className={styles.btnGrp}>
          <Button
            type="secondary"
            style={paddingStyle}
            onClick={() => updatePredictionDriversMode("drillDown")}
            active={buttonStyles.drillDown}
            isSmall
          >
            {"Drill Down"}
          </Button>
          {model && model.plots && model.plots.length > 0 ? (
            <Button
              type="secondary"
              style={paddingStyle}
              onClick={() => updatePredictionDriversMode("marginalEffects")}
              active={buttonStyles.marginalEffects}
              isSmall
            >
              {"Marginal Effects"}
            </Button>
          ) : (
            ""
          )}
          <Button
            type="secondary"
            style={paddingStyle}
            onClick={() => updatePredictionDriversMode("modelComparison")}
            active={buttonStyles.modelComparison}
            isSmall
          >
            {"Model Comparison"}
          </Button>
        </ButtonGroup>
        <div className={styles.predictionDriversCompanionContent}>{displayPredictionMode}</div>
      </div>
    );
  }
}
